module.exports = __webpack_public_path__ + "img/blx.9c654f59.png";